export const getWorkspaceMenuState = (state) =>
  state.workspace.workspaceContent;
